<div class="row">
    <div class="col col__sm--6 col__md--4 u-margin-bottom--20" *ngFor="let homePreview of landingArea.homePreviews">
        <home-landing-preview-card [homePreview]="homePreview" [majorArea]="landingArea.majorArea" [showAddress]="false"></home-landing-preview-card>
    </div>

</div>

<div data-iframe-height=""></div>